import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import useDeleteFavouriteMutation from '../services/useDeleteFavouriteMutation';

interface RemoveFavouriteDialogProps {
  favouriteId: number;
  isOpen: boolean;
  currentFavouriteName: string;
  onClose: () => void;
}

const RemoveFavouriteDialog: FC<RemoveFavouriteDialogProps> = ({
  favouriteId,
  isOpen,
  currentFavouriteName,
  onClose
}) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteFavourite } = useDeleteFavouriteMutation();
  const queryClient = useQueryClient();

  const handleOnRemove = async () => {
    await deleteFavourite(favouriteId);
    queryClient.invalidateQueries(['useFavourites']);
    onClose();
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle variant="h2" sx={{ color: 'primary.main' }}>
        {t('Fav.remove.title')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {t('Fav.remove.message1')} <b>{currentFavouriteName}</b> {t('Fav.remove.message2')}
        </Typography>
        <Stack direction="row" columnGap={2} mt={2} justifyContent="flex-end">
          <Button size="large" variant="contained" onClick={handleOnRemove}>
            {t('Case.button.remove')}
          </Button>
          <Button size="large" variant="contained" onClick={onClose}>
            {t('Case.button.cancel')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveFavouriteDialog;
